import { GET_ALERTS_URL, MICROSOFTAD } from "../constants/constants";
import { getService, getAxiosHeaders } from "../../library/RestAPI";
//dispatch add method when use of Saga
export default async function fetchAllResolvedAlerts(
  pageSize,
  currentPage,
  sortBy,
  severity,
  resolution,
  policy,
  dataSourceTypeFilter,
  datasourceFilter,
  usersFilter,
  policyId,
  sortOrder,
  startTime,
  endTime,
  project,
) {
  let sev = "";
  let res = "";
  let name = "";
  let user = "";
  let paramData = {};
  if (severity && severity.length > 0) {
    severity.forEach((each) => {
      sev = sev + `${each},`;
    });
    sev = sev.slice(0, -1);
    paramData.severity = sev;
  }
  if (datasourceFilter && datasourceFilter.length > 0) {
    datasourceFilter.forEach((each) => {
      user = user + `${each},`;
    });
    user = user.slice(0, -1);
    paramData.dataSourceId = user;
  }
  if (usersFilter && usersFilter.length > 0) {
    usersFilter.forEach((each) => {
      user = user + `${each},`;
    });
    user = user.slice(0, -1);
    paramData.userName = user;
  }
  if (resolution && resolution.length > 0) {
    resolution.forEach((each) => {
      res = res + `${each},`;
    });
    res = res.slice(0, -1);
    paramData.resolutionType = res;
  }
  if (policy && policy.length > 0) {
    policy.forEach((each) => {
      name = name + `${each},`;
    });
    name = name.slice(0, -1);
    paramData.policy = name;
  }
  if (sortBy && sortBy !== "") {
    paramData.sortBy = sortBy;
  }
  if (sortOrder && sortOrder !== "") {
    paramData.direction = sortOrder;
  }
  if (policyId) {
    paramData.policy = policyId;
  }
  if (startTime && endTime) {
    paramData.from = startTime.getTime();
    paramData.to = endTime.getTime();
  }
  const getAlertsURL = () => {
    let defaultTypes = "";

    if (project === "MDR") {
      defaultTypes = "ENTRA,GOOGLEWORKSPACE,MICROSOFTAD";
    } else {
      defaultTypes =
        "POSTGRESQL,MSSQL,MYSQL,SQLSERVER,OTHER,ONEDRIVE,DROPBOX,GOOGLEDRIVE,NTFS";
    }

    // If filter applied → send only selected
    // Else send default static types
    const finalTypes =
      dataSourceTypeFilter && dataSourceTypeFilter.length > 0
        ? dataSourceTypeFilter.join(",")
        : defaultTypes;

    return `${GET_ALERTS_URL}?size=${pageSize}&page=${currentPage}&status=RESOLVED,FALSE_POSITIVE,ACCEPT_RISK&dataSourceType=${finalTypes}`;
  };
  const options = {
    method: "GET",
    url: getAlertsURL(),
    params: paramData,
    headers: getAxiosHeaders(true),
    data: {},
  };
  const response = await getService(options);
  if (response) {
    return response.data;
  }
}
